module.exports = __webpack_public_path__ + "img/final-who-we-comp.1834849d.webp";